export const FORM_INIT = {
    name: '',
    professionalID: '',
    email: '',
    phone: '',
    especialidad: ''
    // name: 'Juan Sandoval',
    // professionalID: '12345678',
    // email: 'jpablo.alejo@nefropolis.com',
    // phone: '3320223334',
    // especialidad: ''
};

const SCHEDULES = {
    sunday: {
        enabled: false,
        start_date: '',
        end_date: '',
        start_period: '',
        end_period: ''
    },
    monday: {
        enabled: false,
        start_date: '',
        end_date: '',
        start_period: '',
        end_period: ''
    },
    tuesday: {
        enabled: false,
        start_date: '',
        end_date: '',
        start_period: '',
        end_period: ''
    },
    wednesday: {
        enabled: false,
        start_date: '',
        end_date: '',
        start_period: '',
        end_period: ''
    },
    thursday: {
        enabled: false,
        start_date: '',
        end_date: '',
        start_period: '',
        end_period: ''
    },
    friday: {
        enabled: false,
        start_date: '',
        end_date: '',
        start_period: '',
        end_period: ''
    },
    saturday: {
        enabled: false,
        start_date: '',
        end_date: '',
        start_period: '',
        end_period: ''
    }
};

export const INSTI_INIT = {
    type: '',
    street: '',
    num_ext: '',
    num_int: '',
    postalCode: '',
    colony: '',
    city: '',
    state: '',
    schedules: SCHEDULES,
    check: false
    // dom: ''
    // type: '',
    // street: 'San Martin de Porres',
    // num_ext: '123',
    // num_int: '',
    // postalCode: '44250',
    // colony: 'Americana',
    // city: 'Guadalajara',
    // state: 'Jalisco'
};

export const DOCTOR_DEFAULT = {
    idMedicoEspecialista: '',
    name: '',
    professionalID: '',
    email: '',
    phone: '',
    especialidad: '',
    promotor_name: ''
};

export const INSTITUTION_DEFAULT = {
    idHospital: 0,
    idTipoHospital: 0, // same as 'type'
    idMedicoEspecialista: 0,
    address: '',
    street: '',
    num_ext: '',
    num_int: '',
    postalCode: '',
    colony: '',
    city: '',
    state: '',
    schedules: SCHEDULES,
    check: false
};